import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBell } from "react-icons/fa";
import axios from "axios";

const Header = () => {
  const navigate = useNavigate();
  const [reminders, setReminders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newCount, setNewCount] = useState(0);

  const getLastSeenTime = () => {
    const time = localStorage.getItem("lastSeenReminderTime");
    return time ? new Date(time) : new Date(0);
  };

  const setLastSeenTime = () => {
    localStorage.setItem("lastSeenReminderTime", new Date().toISOString());
  };

  const fetchReminders = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/reminder-logs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const logs = res.data.logs || [];

      // Sort by sentAt descending (newest first)
      const sortedLogs = logs.sort(
        (a, b) => new Date(b.sentAt) - new Date(a.sentAt)
      );

      setReminders(sortedLogs);

      const unseen = logs.filter(
        (log) => new Date(log.sentAt) > getLastSeenTime()
      );
      setNewCount(unseen.length);
    } catch (error) {
      console.error("Failed to fetch reminders:", error);
    }
  };

  useEffect(() => {
    fetchReminders();
  }, []);

  const openModal = () => {
    setShowModal(true);
    setLastSeenTime(); // mark all as seen
    setNewCount(0); // reset counter
  };

  return (
    <nav className="navbar navbar-expand-lg bg-primary text-dark p-3 shadow">
      <div className="container-fluid d-flex justify-content-between align-items-center flex-nowrap">
        <span
          className="navbar-brand fw-bold text-white m-0 text-truncate"
          onClick={() => navigate("/home")}
          style={{ cursor: "pointer", whiteSpace: "nowrap" }}
        >
          📄 Document Reminder System
        </span>

        {/* Bell Icon with Unseen Count */}
        <div
          className="position-relative me-3"
          style={{ cursor: "pointer" }}
          onClick={openModal}
        >
          <FaBell size={22} className="text-white" />
          {newCount > 0 && (
            <span
              className="badge bg-danger position-absolute top-0 start-100 translate-middle"
              style={{ fontSize: "0.7rem" }}
            >
              {newCount}
            </span>
          )}
        </div>
      </div>

      {/* Reminder Modal */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ backgroundColor: "#00000080" }}
        >
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">🔔 Reminder Logs</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {reminders.length === 0 ? (
                  <p className="text-center">No reminder logs found.</p>
                ) : (
                  reminders.map((log, index) => (
                    <div
                      key={log._id}
                      className="mb-3 p-2 rounded shadow-sm bg-light border"
                    >
                      <p className="mb-2 text-dark">
                        <strong>📩 Message:</strong>{" "}
                        <span className="text-dark">{log.message}</span>
                      </p>

                      <p
                        className="text-dark mb-0"
                        style={{ fontSize: "0.85rem" }}
                      >
                        <strong>🕒 Sent At:</strong>{" "}
                        {new Date(log.sentAt).toLocaleString()}
                      </p>
                      <div className="d-flex flex-wrap gap-2 align-items-center mt-2">
                        <span className="badge bg-success">
                          ✅ Status: {log.status}
                        </span>
                        <span className="badge bg-warning text-dark">
                          ⏳ {log.daysBeforeExpiry} Day(s) Left
                        </span>
                      </div>

                      {index !== reminders.length - 1 && (
                        <hr
                          className="mt-3"
                          style={{ borderTop: "1px solid #ccc" }}
                        />
                      )}
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
